import { convertCurrency } from '@/helpers/currency.helper';

// "AED 60,000" or, with another currency preference, "AED 60,000 (≈ $16,340)". AED is always shown first.
export const useAedAmount = () => {
  const preferences = usePreferencesStore();
  const { formatNumber, formatCurrency } = useFormat();
  const { t } = useI18n();

  const formatAed = (amount: number): string => {
    const aed = formatNumber(Math.round(amount), { maximumFractionDigits: 0 });
    const target = preferences.currency;
    if (!target || target === 'AED') return t('exclusiveUnits.money.aed', { amount: aed });
    const converted = formatCurrency(convertCurrency(amount, 'AED', target), target, { maximumFractionDigits: 0 });
    return t('exclusiveUnits.money.aedConverted', { amount: aed, converted });
  };

  return {
    formatAed,
  };
};
